// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom .avue-crud__menu[data-v-80611700]{display:none!important;height:0;min-height:0}.demo-form-inline[data-v-80611700]{padding:20px 15px 0 20px}", ""]);
// Exports
module.exports = exports;
